"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dateCompareValidationRule(_a) {
    var messages = _a.messages, schema = _a.schema;
    var src = [];
    var sanitized = false;
    src.push('var origValue = value;');
    if (schema.convert === true) {
        sanitized = true;
        src.push("\n      if (!(value instanceof Date)) {\n        value = new Date(value);\n      }\n    ");
    }
    src.push("\n\t\tif (!(value instanceof Date) || isNaN(value.getTime())) {\n\t\t\t" + this.makeError({ actual: 'origValue', messages: messages, type: 'date' }) + "\n      return value;\n    }\n  ");
    if (schema.operator) {
        if (schema.operator.toLowerCase() === 'between') {
            src.push("\n        const from = parent['" + schema.from + "'] ? new Date(parent['" + schema.from + "']) : undefined;\n        const to = parent['" + schema.to + "'] ? new Date(parent['" + schema.to + "']) : undefined;\n        if (from && to && (value < from || value > to)) {\n          " + this.makeError({ actual: 'from', expected: 'to', messages: messages, type: 'dateBetween' }) + "\n        }\n      ");
        }
        if (schema.operator.toLowerCase() === 'gt') {
            src.push("console.log('bbbb', parent['" + schema.to + "'])");
            src.push("const to = parent['" + schema.to + "'] ? new Date(parent['" + schema.to + "']) : undefined;");
            src.push("console.log('aaa', to)");
            src.push("\n        if (to && value <= to) {\n          " + this.makeError({ expected: 'to', messages: messages, type: 'dateGt' }) + "\n        }\n        ");
        }
        if (schema.operator.toLowerCase() === 'gte') {
            src.push("const to = new Date(parent['" + schema.to + "']);");
            src.push("\n        if (value < to) {\n          " + this.makeError({ expected: 'to', messages: messages, type: 'dateGte' }) + "\n        }\n      ");
        }
        if (schema.operator.toLowerCase() === 'lt') {
            src.push("const to = new Date(parent['" + schema.to + "']);");
            src.push("\n        if (value >= to) {\n          " + this.makeError({ expected: 'to', messages: messages, type: 'dateLt' }) + "\n        }\n      ");
        }
        if (schema.operator.toLowerCase() === 'lte') {
            src.push("const to = new Date(parent['" + schema.to + "']);");
            src.push("\n        if (value < to) {\n          " + this.makeError({ expected: 'to', messages: messages, type: 'dateLte' }) + "\n        }\n      ");
        }
    }
    src.push('return value;');
    return {
        sanitized: sanitized,
        source: src.join('\n'),
    };
}
exports.default = dateCompareValidationRule;
//# sourceMappingURL=dateCompareValidationRule.js.map